import { type FC, Fragment } from 'react';

import classNames from 'classnames';

import { selectCollectionTitleObjects } from '../../../ducks/collections/selectors';
import { useAppSelector } from '../../../store/react_redux_typed';
import Ellipsis from '../../ellipsis/ellipsis';

import styles from './tree_breadcrumbs.module.css';

type TreeBreadcrumbsProps = {
  ancestorCollectionIds: string[];
  className?: string;
};
export const TreeBreadcrumbs: FC<TreeBreadcrumbsProps> = ({
  ancestorCollectionIds,
  className,
}) => {
  const breadcrumbObjects = useAppSelector((state) =>
    selectCollectionTitleObjects(state, ancestorCollectionIds),
  );

  const collectionTitles: { [key: string]: string } =
    ancestorCollectionIds.reduce((acc: { [key: string]: string }, id) => {
      const title =
        breadcrumbObjects.find((obj) => obj.id === id)?.title || ' ';
      acc[id] = title;

      return acc;
    }, {});

  const collectionTitleIds = Object.keys(collectionTitles);

  const tooltip = collectionTitleIds
    .map((id) => collectionTitles[id])
    .join(' > ');

  const itemPathStyles = classNames(styles.item_path, className);
  // Implies that parent is root
  if (collectionTitleIds.length === 0) {
    return <div className={itemPathStyles}>/</div>;
  }

  const breadcrumbItems = collectionTitleIds.map((id, index) => (
    <Fragment key={id}>
      <span>
        {collectionTitles[id]}
        {index < collectionTitleIds.length - 1 && ' > '}
      </span>
    </Fragment>
  ));
  return (
    <Ellipsis
      componentProps={{ className: itemPathStyles }}
      tooltipText={`/ ${tooltip}`}
    >
      / {breadcrumbItems}
    </Ellipsis>
  );
};
